import { render, staticRenderFns } from "./ipDetail.vue?vue&type=template&id=1184d0a3&scoped=true&"
import script from "./ipDetail.vue?vue&type=script&lang=js&"
export * from "./ipDetail.vue?vue&type=script&lang=js&"
import style0 from "./ipDetail.vue?vue&type=style&index=0&id=1184d0a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1184d0a3",
  null
  
)

export default component.exports